import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTextField = styled(TextField)({
  padding: '4px 16px',
  border: 'none',
  '& .MuiOutlinedInput-root': {
    height: 'auto',
    '& .MuiOutlinedInput-input': {
      padding: '8px 14px',
    },
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
});